import Operation from './Operation.js';

class EditResolution extends Operation {
    constructor(mix, event, resolution) {
        super(mix, event.getType());

        this.event = event;
        this.resolution = resolution;
    }

    execute() {
        if (this.resolution === undefined) {
            return;
        }
        this.event.resolution = this.resolution;
    }
}

export default EditResolution ;
